import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, FOLDERPATH } from "../Constants/config";

import {
  EDUCATION_LOADING,
  EDUCATION_SUCCESS,
  EDUCATION_FAILED,
  EDUCATION_ADD_LOADING,
  EDUCATION_ADD_SUCCESS,
  EDUCATION_ADD_FAILED,
  EDUCATION_REMOVE_LOADING,
  EDUCATION_REMOVE_SUCCESS,
  EDUCATION_REMOVE_FAILED,
  EDUCATION_UPDATE_CAMPUS_HIRE_LOADING,
  EDUCATION_UPDATE_CAMPUS_HIRE_SUCCESS,
  EDUCATION_UPDATE_CAMPUS_HIRE_FAILED,
  EDUCATION_SAVE_LOADING,
  EDUCATION_SAVE_SUCCESS,
  EDUCATION_SAVE_FAILED,
  MRL_DOCUMENT_LOADING,
  MRL_DOCUMENT_SUCCESS,
  MRL_DOCUMENT_FAILED,
  STATE_UNIVERSITY_LOADING,
  STATE_UNIVERSITY_SUCCESS,
  STATE_UNIVERSITY_FAILED
} from "../Constants/educationConstants";

import { handleApiError } from "../Helper/actionHelper";

export const getEducation = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
    dispatch({ type: EDUCATION_LOADING });
    const requestData = {
      token:
      userLocalData.id,
        "group": 3,
        "referenceNo": "291664272814"
    };
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/checkDetail",
      requestData,
      {
        headers: headers,
      } 
    );

    dispatch({
      type: EDUCATION_SUCCESS,
      payload: data,
    });

    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    dispatch({
      type: EDUCATION_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};


export const addEducation = () => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: EDUCATION_ADD_LOADING });

    const requestData = {
      token:
      userLocalData.id,
        // "group": 3,
        // "referenceNo": "1234567890"
    };
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/addEducationCheck",
      requestData,
      {
        headers: headers,
      } 
    );

    dispatch({
      type: EDUCATION_ADD_SUCCESS,
      payload: data,
    });

    handleApiError(data); //in case API return 200 with error details

  } catch (error) {
    dispatch({
      type: EDUCATION_ADD_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};



export const updateCampusHireEducation = (value) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: EDUCATION_UPDATE_CAMPUS_HIRE_LOADING });

    const requestData = {
      token:
      userLocalData.id,
      campusValue:value,
        // "group": 3,
        // "referenceNo": "1234567890"
    };
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/updateCampusElementValue",
      requestData,
      {
        headers: headers,
      } 
    );

    dispatch({
      type: EDUCATION_UPDATE_CAMPUS_HIRE_SUCCESS,
      payload: data,
    });

    handleApiError(data); //in case API return 200 with error details

  } catch (error) {
    dispatch({
      type: EDUCATION_UPDATE_CAMPUS_HIRE_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};



export const removeEducation = (caseCheckId, removedigi=0, index, callback=()=>{}) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: EDUCATION_REMOVE_LOADING });

    const requestData = {
      token:
      userLocalData.id,
      remove_digi: removedigi,
      casechkid:caseCheckId,
        // "group": 3,
        // "referenceNo": "1234567890"
    };
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/removeEducationCheck",
      requestData,
      {
        headers: headers,
      } 
    );

    dispatch({
      type: EDUCATION_REMOVE_SUCCESS,
      payload: data,
    });

    callback(index);

    handleApiError(data); //in case API return 200 with error details

  } catch (error) {
    dispatch({
      type: EDUCATION_REMOVE_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};


export const saveEducation = (record,isadd,callback=()=>{}) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: EDUCATION_SAVE_LOADING });

    const requestData = {
      token:
      userLocalData.id,
      is_add_edu: isadd,
      ...record
    };

    console.log(requestData);
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };
    const { data:result } = await axios.post(FOLDERPATH + 
      "/CandidateApi/saveCheckDetails",
      requestData,
      {
        headers: headers,
      } 
    );
    
    if (result.status === "success") {

      const { data } = result;
      // if(isadd==1)
      //   {
      //     dispatch(addEducation())
      //   }

    dispatch({
      type: EDUCATION_SAVE_SUCCESS,
      payload: data,
    });

    const msg = "Saved Successfully";

    toast.success(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    callback(isadd,data);

  }

  handleApiError(result); //in case API return 200 with error details

  } catch (error) {
    dispatch({
      type: EDUCATION_SAVE_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};

export const deleteSaveEducation = () => (dispatch) => {
  dispatch({
    type: EDUCATION_SAVE_SUCCESS,
    payload: [],
  });
};


// export const sendPersonalDetails = (formData) => async (dispatch) => {
//   try {
//     dispatch({ type: SAVE_PERSONAL_DETAILS_LOADING });
//     const requestData = {
//       token:
//         "GOaNMmi/iOhOGjFhu9AvptrNjxpus9dsMUmb5LwTq5Y=:dbvJdVvhe5dqiC33I3oXpA==",
//     };
//     for (var i in formData) {
//       if (i === "customfields_data") {
//         requestData[i] = formData[i];
//       } else if (formData[i].length > 0) {
//         requestData[i] = formData[i];
//       }
//     }
//     const headers = {
//       "Content-Type": "application/json",
//       Username: "ibridge",
//       Password: "ibridge@2020",
//     };

//     const { data } = await axios.post(FOLDERPATH + 
//       "/CandidateApi/saveProfileDetails",
//       requestData,
//       {
//         headers: headers,
//       }
//     );
//     console.log(data);
//     dispatch({
//       type: SAVE_PERSONAL_DETAILS_SUCCESS,
//       payload: data,
//     });
//   } catch (error) {
//     dispatch({
//       type: SAVE_PERSONAL_DETAILS_FAILED,
//       payload:
//         error.response && error.response.data.message
//           ? error.response
//           : error.response,
//     });
//   }
// };

// export const uploadFileViaMultipart = (mode, file) => async (dispatch) => {
//   try {
//     dispatch({ type: UPLOAD_FILE_MULTIPART_LOADING });

//     let formData = new FormData();
//     formData.append(
//       "token",
//       "GOaNMmi/iOhOGjFhu9AvptrNjxpus9dsMUmb5LwTq5Y=:dbvJdVvhe5dqiC33I3oXpA=="
//     );
//     formData.append("mode", mode);
//     formData.append(mode, file);

//     const headers = {
//       "Content-Type": "application/json",
//       Username: "ibridge",
//       Password: "ibridge@2020",
//     };

//     const { data } = await axios.post(FOLDERPATH + 
//       "/CandidateApi/uploadFiles",
//       formData,
//       {
//         headers,
//       }
//     );

//     dispatch({
//       type: UPLOAD_FILE_MULTIPART_SUCCESS,
//       payload: data,
//     });
//   } catch (error) {
//     dispatch({
//       type: UPLOAD_FILE_MULTIPART_FAILED,
//       payload:
//         error.response && error.response.data.message
//           ? error.response
//           : error.response,
//     });
//   }
// };



export const getMRLDocument = (record, caseCheckId, callback=()=>{}) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: MRL_DOCUMENT_LOADING });

    const requestData = {
      token:
      userLocalData.id,
      ...record
    };

    console.log(requestData);
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };
    // const { data } = await axios.post(FOLDERPATH + 
    //   "/CandidateApi/getMRLDocument",
    //   requestData,
    //   {
    //     headers: headers,
    //   } 
    // );
    const { data } = await axios.post(FOLDERPATH + 
      "/InstantNid/getMRLRequiredDocument",
      requestData,
      {
        headers: headers,
      } 
    );
    
    callback(data);
    if (data?.msg === "success") {

    dispatch({
      type: MRL_DOCUMENT_SUCCESS,
      payload: {
        [caseCheckId] : data?.data ? {...data?.data, verificationSourceId : record?.org_id} : {}
      },
    });

    const msg = "Saved Successfully";

    // toast.success(msg, {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });
  
  }

  handleApiError(data); //in case API return 200 with error details

  } catch (error) {
    dispatch({
      type: MRL_DOCUMENT_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};

export const removePreviousMRLDocument = (record, caseCheckId, callback = () => {}) => async (dispatch) => {
  try {

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: MRL_DOCUMENT_LOADING });

    const requestData = {
      token:
      userLocalData.id,
      ...record
    };

    console.log(requestData);
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };
    // const { data } = await axios.post(FOLDERPATH + 
    //   "/CandidateApi/getMRLDocument",
    //   requestData,
    //   {
    //     headers: headers,
    //   } 
    // );
    const { data } = await axios.post(FOLDERPATH + 
      "/InstantNid/removeEduEmpCheckData",
      requestData,
      {
        headers: headers,
      } 
    );
    
    
    callback(data);
    dispatch({
      type: MRL_DOCUMENT_SUCCESS,
      payload: {
        [caseCheckId] : {}
      },
    });
  

  handleApiError(data); //in case API return 200 with error details

  } catch (error) {
    dispatch({
      type: MRL_DOCUMENT_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};

export const fetchStateUniversity1 = (payload,callback=()=>{}) => async (dispatch) => {
  try {
    debugger
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: STATE_UNIVERSITY_LOADING });

    const requestData = {
      token:
      userLocalData.id,
      ...payload
    };

    console.log(requestData);
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };
    const { data:result } = await axios.post( 
      "GenericApi/getUniversity",
      requestData,
      {
        headers: headers,
      } 
    );
    
    if (result.status === "success") {

      const { data } = result;
      // if(isadd==1)
      //   {
      //     dispatch(addEducation())
      //   }

    dispatch({
      type: STATE_UNIVERSITY_SUCCESS,
      payload: data,
    });

    const msg = "Saved Successfully";

    toast.success(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    callback(data);

  }

  handleApiError(result); //in case API return 200 with error details

  } catch (error) {
    dispatch({
      type: STATE_UNIVERSITY_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};

export const fetchStateUniversity = (payload, idx, callback=()=>{}) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    // dispatch({ type: SAVE_REASON_LOADING });
    let requestData = {
      ...payload,
      token: userLocalData.id,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    // const { data } = await axios.post(
      // "GenericApi/getUniversity",
      const { data } = await axios.post(FOLDERPATH + 
        "/GenericApi/getUniversity",
      requestData,
      {
        headers: headers,
      }
    );
    if(data?.data){
      // let optionsArr = []
      // let res = data?.data.map((item) => {
      //   return(
      //     optionsArr.push(item)
      //   )
      // })
      // console.log(optionsArr)
      // localStorage.setItem('' , JSON.stringify(optionsArr));
      callback(data,idx);
    }
    // callback(data);
    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error("Something went wrong", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    // dispatch({
    //   type: SAVE_REASON_FAILED,
    //   payload:
    //     error.response && error.response.data.message
    //       ? error.response
    //       : error.response,
    // });
    // console.log('INSUFF_ERROR..', error)

    handleApiError(error);
  }
};

export const getCityAndState = (payload, callback=()=>{}) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    // dispatch({ type: SAVE_REASON_LOADING });
    let requestData = {
      ...payload,
      token: userLocalData.id,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    // const { data } = await axios.post(
      // "GenericApi/getUniversity",
      const { data } = await axios.post(FOLDERPATH + 
        "/InstantNid/getCityStateName",
      requestData,
      {
        headers: headers,
      }
    );
    
    if(data?.data){
      // let optionsArr = []
      // let res = data?.data.map((item) => {
      //   return(
      //     optionsArr.push(item)
      //   )
      // })
      // console.log(optionsArr)
      // localStorage.setItem('' , JSON.stringify(optionsArr));
      callback(data);
    }
    // callback(data);
    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error("Something went wrong", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    // dispatch({
    //   type: SAVE_REASON_FAILED,
    //   payload:
    //     error.response && error.response.data.message
    //       ? error.response
    //       : error.response,
    // });
    // console.log('INSUFF_ERROR..', error)

    handleApiError(error);
  }
};

export const getUpdatedDocsEducation = (callback = () =>{}) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
    const requestData = {
      token:
      userLocalData.id,
        "group": 3,
        "referenceNo": "291664272814"
    };
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/checkDetail",
      requestData,
      {
        headers: headers,
      } 
    );

    callback(data);

    handleApiError(data); //in case API return 200 with error details
  } catch (error) {

    handleApiError(error);
  }
};
